/*

----- Geolocation ----- 
Using the geolocation api https://developer.mozilla.org/en-US/docs/Web/API/Navigator/geolocation to get the position / location of the device programatically which returns the logitude and latitude.
*/


var instances = {};

function setContext(id, value) {
    return instances[id]['context'] = value;
}

function getContext(id) {
    return instances[id]['context'];
}

function setLongitudeInput(id, value) {
    return instances[id]['longitude-input'] = value;
}

function getLongitudeInput(id) {
    return instances[id]['longitude-input'];
}

function setLatitudeInput(id, value) {
    return instances[id]['latitude-input'] = value;
}

function getLatitudeInput(id) {
    return instances[id]['latitude-input'];
}

function setAccuracyInput(id, value) {
    return instances[id]['accuracy-input'] = value;
}

function getAccuracyInput(id) {
    return instances[id]['accuracy-input'];
}

function setSearchInput(id, value) {
    return instances[id]['search-input'] = value;
}

function getSearchInput(id) {
    return instances[id]['search-input'];
}

function initialiseAll() {
    // Get all instances.
    let elements = $('[' + expressSelectors()['geolocation']['initialise'] + ']');
    // If any.
    if (elements) {
        elements.each(function() {
            // Get context.
            let context = $(this);
            // Initialise.
            let init = initialise(context);
        });
    }
}

function initialise(context) {
    // Get instance id.
    let id = context.attr(expressSelectors()['geolocation']['initialise']);
    // If no Id then generate one.
    if (!id) {
        context.attr(expressSelectors()['geolocation']['initialise'], generateId());
        id = context.attr(expressSelectors()['geolocation']['initialise']);
        instances[id] = {};
    } else {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Geolocation: Instance already initialised skipping.");
        }
        return false;
    }
    // Update instance.
    setContext(id, context);

    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Geolocation: Initialising", id);
    }
    
    // Get Longitude input name.
    let longitudeInput = context.attr(expressSelectors()['geolocation']['longitude-input']);
    // If defined then create jQuery object.
    if (longitudeInput) {
        longitudeInput = $('input[name="' + longitudeInput + '"]');
        // Update instance.
        setLongitudeInput(id, longitudeInput);
    }
    // Get Latitude input name.
    let latitudeInput = context.attr(expressSelectors()['geolocation']['latitude-input']);
    // If defined then create jQuery object.
    if (latitudeInput) {
        latitudeInput = $('[name="' + latitudeInput + '"]');
        // Update instance.
        setLatitudeInput(id, latitudeInput);
    }
    // Get Accuracy input name.
    let accuracyInput = context.attr(expressSelectors()['geolocation']['accuracy-input']);
    // If defined then create jQuery object.
    if (accuracyInput) {
        accuracyInput = $('[name="' + accuracyInput + '"]');
        // Update instance.
        setAccuracyInput(id, accuracyInput);
    }
    // Get search input.
    let searchInput = context.attr(expressSelectors()['geolocation']['search-input']);
    // If defined then create jQuery object.
    if (searchInput) {
        searchInput = $('[name="' + searchInput + '"]');
        // Update instance.
        setSearchInput(id, searchInput);
    }

    listeners(id);
}

function listeners(id) {
    // Get context.
    let context = getContext(id);
    // Add click listener.
    context.on('click', function(event) {
        // Prevent any default behaviour.
        event.preventDefault();
        // Button context.
        let button = $(this);
        // Do lookup.
        getLocation().then((response) => {
            // Coordinates.
            let coordinates = response['coords'];
            // Get longitude input.
            let longitudeInput = getLongitudeInput(id);
            // If longitude input configured then output.
            if (longitudeInput) {
                longitudeInput.val(coordinates['longitude']);
                // Trigger change.
                longitudeInput.trigger('change');
            }
            // Get latitude input.
            let latitudeInput = getLatitudeInput(id);
            // If latitude input configured then output.
            if (latitudeInput) {
                latitudeInput.val(coordinates['latitude']);
                // Trigger change.
                latitudeInput.trigger('change');
            }
            // Get accuracy input.
            let accuracyInput = getAccuracyInput(id);
            // If latitude input configured then output.
            if (accuracyInput) {
                accuracyInput.val(coordinates['accuracy']);
                // Trigger change.
                accuracyInput.trigger('change');
            }
            // Get search input.
            let searchInput = getSearchInput(id);
            // If search input conifgured then reset it.
            if (searchInput) {
                searchInput.val("");
            }
            // If in a form then submit it.
            let form = button.parents('form');
            // TODO: This will need to be extended if we do not want to automatically submit the form.
            if (form) {
                form.trigger('submit');
            }

        }).catch((error) => {
            AXISDebug.output(3,"Geolocation:", error);
        });

    });
}

// Get the device's location.
function getLocation() {
    return new Promise((resolve, reject) => {
        // lookup options.
        let options = {
            enableHighAccuracy: true, // This can result in slower response times or increased power consumption (with a GPS chip on a mobile device for example).
            timeout: 5000, // maximum length of time (in milliseconds) the device is allowed to take in order to return a position.
            maximumAge: 0, // maximum age in milliseconds of a possible cached position that is acceptable to return
        }
        // Get location.
        navigator.geolocation.getCurrentPosition(resolve, reject, options);
    });
}

var AXISGeoLocation = $.AXISGeoLocation = {
    initialiseAll: () => {
        return initialiseAll();
    },
    initialise: (context) => {
      return initialise(context);
    }

}

export { AXISGeoLocation }
